import user_get from "frontend/constants/user_get"
import fire_event from "frontend/dom/fire_event"
import on from "frontend/dom/on"
import clear_ajax_cache from "frontend/navigation/clear_ajax_cache"
import messages from "frontend/state/messages"
import { get_translations } from "workflow/utils/make_translations"
import translate from "workflow/utils/render_string"
import virtual from "workflow/vue/3/virtual"

export default virtual({
  data: () => user_get(),
  mounted() {
    on("site_init", null, this.dispatch_event)
  },
  methods: {
    dispatch_event(initial = true) {
      if (this.id) {
        fire_event(document, "user_login", { initial })

        const current = new Date().getTime() / 1000

        if (current - this.signup_time <= 5) {
          fire_event(document, "user_signup", { initial })
        }
      } else {
        fire_event(document, "user_logout", { initial })
      }
    },
  },
  computed: {
    is_just_user: function () {
      return this.id && !this.is_staff ? true : false
    },
    is_just_staff: function () {
      return this.id && this.is_staff ? true : false
    },
  },
  watch: {
    id: function (id) {
      if (id) {
        get_translations("actions").then(actions =>
          messages.add(
            translate(actions.LOGIN, {
              user: this.email || this.name || this.id,
            })
          )
        )
      }

      this.dispatch_event(false)

      clear_ajax_cache()
    },
    has_discount: () => clear_ajax_cache(),
  },
})
